/**
 * TanStack Query hooks for `manual-approval-affiliate-workflow`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	manualApprovalAffiliateWorkflowQueryKeys,
	type CreateManualApprovalAffiliateWorkflowBody,
	type ListManualApprovalAffiliateWorkflowResponse,
	type ManualApprovalAffiliateWorkflowRow,
} from "./api";

export function useManualApprovalAffiliateWorkflowList(): UseQueryResult<ListManualApprovalAffiliateWorkflowResponse, Error> {
	return useQuery({
		queryKey: manualApprovalAffiliateWorkflowQueryKeys.list(),
		queryFn: list,
	});
}

export function useManualApprovalAffiliateWorkflowCreate(): UseMutationResult<ManualApprovalAffiliateWorkflowRow, Error, CreateManualApprovalAffiliateWorkflowBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: manualApprovalAffiliateWorkflowQueryKeys.all });
		},
	});
}

export function useManualApprovalAffiliateWorkflowDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: manualApprovalAffiliateWorkflowQueryKeys.all });
		},
	});
}
